//appreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const ApPreset = definePreset(Aura, {

  semantic: {

    primary: {
      50: '#ecf0ff',
      100: '#d6dfff',
      200: '#aac0fe',
      300: '#79a1fe',
      400: '#2f83fd',
      500: '#0b67d3',
      600: '#064ea1',
      700: '#033674',
      800: '#022656',
      900: '#011738',
      950: '#000d26'
    }

  },
});

export default ApPreset;
